export const doctorStatusEnum = {
  Pending: 1,
  Verified: 2,
  Rejected: 3,
  NotSubmitted: 4,

  getKeyByValue(value) {
    return Object.keys(this).find(key => this[key] === value);
  },
};

export const doctorStatusColorEnum = colors => ({
  [doctorStatusEnum.Pending]: {
    color: colors.blueMain,
    backgroundColor: colors.blueLight,
  },
  [doctorStatusEnum.Verified]: {
    color: colors.greenMain,
    backgroundColor: colors.greenLight,
  },
  [doctorStatusEnum.Rejected]: {
    color: colors.redDark,
    backgroundColor: colors.redLight,
  },
  [doctorStatusEnum.NotSubmitted]: {
    color: colors.orangeDark,
    backgroundColor: colors.orangeLight,
  },
});
